import { render, staticRenderFns } from "./HistoryUx.vue?vue&type=template&id=45566418&scoped=true"
import script from "./HistoryUx.vue?vue&type=script&lang=js"
export * from "./HistoryUx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45566418",
  null
  
)

export default component.exports